export default "__VITE_ASSET__WUYPtwwO__"